import i18next from 'i18next';

import { getGiftCards } from 'services/ErplyAPI/payment';
import { openModalPage, previousModalPage } from 'actions/modalPage';
import { getSelectedPos } from 'reducers/PointsOfSale';
import * as api from 'services/ErplyAPI/products';
import { GIFTCARDS_UPDATE, GIFTCARDTYPES_UPDATE } from 'constants/giftcards';
import { doClientRequest } from 'services/ErplyAPI/core/ErplyAPI';
import { modalPages } from 'constants/modalPage';
import { CartItem } from 'containers/Forms/GiftCardSerial/types';
import { getProductsInShoppingCart } from 'reducers/ShoppingCart';
import { getSetting } from 'reducers/configs/settings';
import { getPluginLifecycleHook } from 'reducers/Plugins';

import { addError, addWarning, dismissType } from './Error';
import { addProduct } from './ShoppingCart';

export const fetchRegularGiftCards = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { warehouseID } = getSelectedPos(state);
    const params = {
      regularGiftCards: 1,
      warehouseID,
    };
    // TODO: need to find out if we need to fetch ALL the existing gift cards (provide from and count to the request)
    // Also research if it would make sense to add "active: 1" flag to get only active gift card products
    const { records } = await api.getProducts(params);
    const payload: { name: string; vatRateID: any; productID: any }[] = [];
    records.forEach(card => {
      payload.push({
        name: card.name,
        vatRateID: card.vatrateID,
        productID: card.productID,
      });
    });
    payload.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
    // region What is this? doesn't look like it's used by anything
    let counter = 0;
    payload.forEach(c => {
      Object.assign(c, { value: counter });
      counter += 1;
    });
    // endregion
    await dispatch({
      type: GIFTCARDS_UPDATE,
      payload,
    });
    return payload;
  } catch (e) {
    console.error('Failed to load regular gift cards', e);
  }
};

export const fetchGiftcardTypes = () => async (dispatch, getState) => {
  try {
    const types = await doClientRequest({
      request: 'getGiftCardTypes',
    });
    dispatch({
      type: GIFTCARDTYPES_UPDATE,
      payload: types,
    });
  } catch (err) {
    console.error('Failed to load gift card types', err);
  }
};

export const addGiftCardToCartIfSerialUnused = ({
  productID,
  giftCardSerial,
}) => async (dispatch, getState) => {
  const cart: CartItem[] = getProductsInShoppingCart(getState());
  const shouldOpenProductView = !getSetting(
    'touchpos_disable_product_row_auto_open',
  )(getState());

  const { before, on, after } = getPluginLifecycleHook(
    // @ts-ignore
    'onAddSerialGiftCardProduct',
  )(getState());

  await dispatch(before({ productID, giftCardSerial }));

  dispatch(
    addWarning(
      i18next.t('giftcard:alerts.fetchingSerial', { serial: giftCardSerial }),
      {
        dismissible: true,
        errorType: 'giftCardSerialFetching',
        selfDismiss: 30000,
      },
    ),
  );
  const exists = cart.some(c => c.giftCardSerial === giftCardSerial);
  if (exists) {
    dispatch(dismissType('giftCardSerialFetching'));
    dispatch(
      addWarning(
        i18next.t('giftcard:alerts.serialAlreadyAdded', {
          serial: giftCardSerial,
        }),
        {
          dismissible: true,
          errorType: 'giftCardSerialAlreadyAdded',
          selfDismiss: 3000,
        },
      ),
    );
    return;
  }
  try {
    const result = await getGiftCards({ code: giftCardSerial });
    if (result.length) {
      dispatch(dismissType('giftCardSerialFetching'));
      dispatch(
        addError(
          i18next.t('giftcard:alerts.serialAlreadyUsed', {
            serial: giftCardSerial,
          }),
          {
            dismissible: true,
            errorType: 'giftCardSerialAlreadyUsed',
            selfDismiss: 3000,
          },
        ),
      );
      return;
    }
  } catch (e) {
    const error = e as Error;
    dispatch(addError(error.message));
  } finally {
    dispatch(dismissType('giftCardSerialFetching'));
  }

  try {
    const giftCardProduct = await dispatch(
      on({ productID, giftCardSerial }, { productID, giftCardSerial }),
    );

    dispatch(addProduct(giftCardProduct));
    dispatch(previousModalPage());

    if (shouldOpenProductView) {
      dispatch(
        openModalPage({
          component: modalPages.ProductOrderView,
        }),
      );
    }
    await dispatch(after({ productID, giftCardSerial }, null));
  } catch (err) {
    console.error('Failed to add giftcard product to cart automatically', err);
  }
};
